module.exports = __webpack_public_path__ + "img/img-lung_leson.cc86c9a2.svg";